import React from 'react'
import PropTypes from 'prop-types'
import { Drawer, DrawerHeader, QuickView, ProductPanel } from '@sainsburys-tech/bolt'
import Image from '../../../helpers/Image/Image'
import * as Styled from './AllProductsView.styles'
import { quickviewDetailsTracking } from './hot-spot.tracking'
import { cleanString } from '../../../helpers/ComponentHelper'

const AllProductsView = ({ show, onClose, imageSrc, altText, partNumbers, 'data-test': dataTest, heading }) => {
  const moreDetailsButtonOnClick = (partNumber) => {
    const productType = partNumbers.includes(partNumber) ? 'main' : 'recommendation'
    const productData = [
      {
        id: partNumber,
        hotspotProductType: productType
      }
    ]
    quickviewDetailsTracking('hotspotLb_moreDetails', heading, productData)
    const trackingParams = `?clickOrigin=hotspot:${cleanString(heading)}:${productType}`

    window.location.href = `/product/${partNumber}${trackingParams}`
  }

  return (
    <Drawer show={show} onClose={onClose} data-test={dataTest}>
      <DrawerHeader data-test={dataTest}> A closer look </DrawerHeader>
      <Styled.ProductsContentWrapper data-test={`${dataTest}-content-wrapper`}>
        <Styled.ImageWrapper data-test={`${dataTest}-image-wrapper`}>
          <Image src={imageSrc} responsive data-test={`${dataTest}-image`} alt={altText} smart />
        </Styled.ImageWrapper>
        <QuickView.ProductFetch
          fetch={show}
          partNumbers={partNumbers}
          render={({ products }) => {
            return Object.entries(products).map((product, index) => {
              const productAttributes = product[1].data.attributes
              const price = product[1].included.find((included) => included.type === 'prices')?.attributes
              return (
                <ProductPanel
                  partNumber={product[0]}
                  name={productAttributes.name}
                  price={price.now}
                  moreDetailsButtonOnClick={moreDetailsButtonOnClick}
                  key={`product-panel-${index}`}
                  data-test={`${dataTest}-product-panel-${index}`}
                  moreDetailsButton
                />
              )
            })
          }}
        />
      </Styled.ProductsContentWrapper>
    </Drawer>
  )
}

AllProductsView.displayName = 'AllProductsView'

AllProductsView.productTypes = {
  /**
   * Prop toggle the visibility of the All Product view
   */
  show: PropTypes.bool,
  /**
   * Optional callback fn prop fired when drawer is closed
   */
  onClose: PropTypes.func,
  /**
   * [REQUIRED] The main Image displayed in All Products View
   */
  imageSrc: PropTypes.string.isRequired,
  /**
   * [REQUIRED] Array of product IDs to display product Panels for
   */
  partNumbers: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Optional heading prop used for tracking
   */
  heading: PropTypes.string
}

AllProductsView.defaultProps = {
  show: false,
  onClose: () => {},
  'data-test': 'component-all-products-view'
}

export default AllProductsView
